import styled from '@emotion/styled';
import COLORS from '$variables/colors';
import { typography, spacing } from '$variables/theme';

export const List = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  border: 1px solid ${COLORS.grey};
  background-color: ${COLORS.white};
  box-sizing: border-box;
`;

export const ListItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  border-bottom: 1px solid ${COLORS.grey};

  &:last-of-type {
    border-bottom: none;
  }

  :hover {
    background-color: ${({ onClick }) =>
      onClick ? COLORS.shadow : 'transparent'};
  }

  cursor: ${({ onClick }) => (onClick ? 'pointer' : 'default')};
`;

export const ListItemContent = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

export const ListItemAvatar = styled.div`
  margin-right: ${spacing.xSmall};
  display: flex;
`;

export const ListItemPrimaryText = styled.div`
  font-size: 14px;
  font-weight: ${typography.fontWeightMedium};
  line-height: 20px;
  color: ${({ disabled }) => (disabled ? COLORS.grey1 : 'inherit')};
`;

export const ListItemSecondaryText = styled.div`
  font-size: 12px;
  font-weight: ${typography.fontWeightRegular};
  line-height: 20px;
  color: ${COLORS.black};
  margin-top: 2px;
`;

export const ListItemTertiaryText = styled(ListItemSecondaryText)`
  color: ${COLORS.shadow5};
  margin-top: 2px;
`;

export const EmptyListItemText = styled.div`
  font-size: 16px;
  line-height: 20px;
  color: ${COLORS.grey3};
`;

export const ListItemHeaderText = styled(ListItemPrimaryText)`
  font-size: 16px;
  font-weight: ${typography.fontWeightBold};
`;

export const ListItemSecondaryHeaderText = styled(ListItemPrimaryText)`
  font-size: 14px;
  font-weight: ${typography.fontWeightBold};
`;

export const TopDecorations = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: ${spacing.xSmall};
`;

export const TopDecoration = styled.span`
  margin-right: ${spacing.xSmall};
  display: flex;
`;

export const RightDecorations = styled.div`
  display: flex;
  flex-direction: row;
`;

export const RightDecoration = styled.div`
  display: flex;
  margin-left: ${spacing.xSmall};
`;
